import { TApi } from '@/types/common';
import { requestGet } from '@/utils/request';

export function getSuperAuthorityItem(): Promise<TApi<string[]>> {
  return requestGet('/companies/api/permission/group/super/admin', {});
}
